const course = {

    // headings
    create: 'Create Course',
    edit: 'Edit Course',

    // List
    courseList: 'Course List',
    searchCriteria: 'Filter Preset',
    presetName: 'Enter Preset Name',
    action: 'Action',

    // Tabs
    tabGeneral: 'General',
    tabAudit: 'Audit Log',

    // Labels
    courseID: 'ID',
    courseTitle: 'Course Title',
    courseCode: 'Course Code',
    SBSCredits: 'SBS Credits',
    ECTSCredits: 'ECTS Credits',

    // grade preview table headers
    percentage: 'Percentage',
    finalExamDate: 'Final Exam Date',
    major: 'Major',
    error: 'Error',

};

export default course;